import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import { absolute } from '../../components/AnimatedRoutes';
import { getTickets } from '../../../../ducks/user/user';
import Flash from '../../components/Flash';
import Header from '../../components/Header';
import TicketList from '../../components/TicketList';
import withUser from '../../../../components/withUser';

const propTypes = {
  tickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    checkin_code: PropTypes.string.isRequired,
  })),
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  user: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  error: PropTypes.oneOfType([
    PropTypes.shape({
      response: PropTypes.shape({}),
    }),
    PropTypes.bool,
  ]),
  ticketsError: PropTypes.oneOfType([
    PropTypes.shape({
      response: PropTypes.shape({}),
    }),
    PropTypes.bool,
  ]),
};

class Tickets extends React.Component {
  componentDidMount() {
    this.getTickets();
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    if (user !== prevProps.user) {
      this.getTickets();
    }
  }

  getTickets = () => {
    const { dispatch, user } = this.props;
    if (user) {
      dispatch(getTickets());
    }
  }

  render() {
    const {
      error,
      history,
      loading,
      tickets,
      ticketsError,
      user,
    } = this.props;

    const sortedTickets = tickets && tickets.slice().sort((a, b) => (
      moment(b.ticket_type?.event.local_start_time).diff(a.ticket_type?.event.local_start_time)
    ));

    return (
      <>
        <Header
          onBack={() => history.goBack()}
        >
          My tickets
        </Header>
        <Flash
          title="Whoops!"
          message={ticketsError?.json?.error_description}
          error
        />
        <TicketList
          tickets={sortedTickets}
          loading={loading}
          user={user}
          fadePast
          error={error}
          onReload={() => this.getTickets()}
        />
      </>
    );
  }
}

Tickets.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.getIn(['user', 'error']),
    loading: state.getIn(['user', 'loading']),
    tickets: state.getIn(['user', 'tickets']),
    ticketsError: state.getIn(['user', 'tickets_error']),
  };
}

export default withUser(connect(mapStateToProps)(absolute(Tickets)));
